/* eslint-disable import/no-cycle */
/* eslint-disable no-unused-vars */
import React from "react";
import create from "zustand";
import EnginePanel from "./engine/EnginePanel";

const store = (set) => ({
  configuratorUI: null,
  setConfiguratorUI: (configuratorUI) => set({ configuratorUI }),
});

export const useConfiguratorStore = create(store);
export const ConfiguratorState = useConfiguratorStore.getState;

export const Configurator = () => {
  const configuratorUI = useConfiguratorStore((state) => state.configuratorUI);
  console.log("configuratorUI", configuratorUI);
  return (
    configuratorUI && (
      <div>
        {/* <CssBaseline /> */}
        <EnginePanel templateConfig={configuratorUI} />
      </div>
    )
  );
};
